import React from 'react';
import { KibCarousel, KibCarouselItem } from '@chewy/kib-carousels-react';
import '@chewy/kib-carousels-styles/dist/styles/kib-carousel.css';
import { PetProfileArticle } from '../../types/Articles';
import CarouselLoadingState from './CarouselLoadingState';
import Article from './Article';
import './articles.scss';

interface ArticleProps {
  articles: PetProfileArticle[] | [];
  isLoading: boolean;
  isMinLarge: boolean;
  maxArticlesToDisplay?: number;
  minArticlesNeeded?: number;
  'data-testid'?: string;
  isSpecialtyPet?: Boolean;
}

const Articles = ({
  articles = [],
  isLoading,
  isMinLarge,
  'data-testid': dataTestId,
  maxArticlesToDisplay = 5,
  minArticlesNeeded = 4,
  isSpecialtyPet,
}: ArticleProps) => {
  const displayArticles = articles
    .filter((item) => item.link && item.title)
    .slice(0, maxArticlesToDisplay);
  const showArticles = displayArticles.length >= minArticlesNeeded || isLoading;

  if (showArticles) {
    return (
      <section className="pet-profile-articles">
        {isLoading ? (
          <CarouselLoadingState />
        ) : (
          <>
            <div className="pet-profile-articles__heading">One for the Humans</div>
            <div className="pet-profile-articles__subtitle">
              Go-to guides and tips for a happy, healthy pet
            </div>
            <KibCarousel data-testid={dataTestId}>
              {displayArticles.map((article, index) => (
                <KibCarouselItem
                  key={index}
                  className="rpm-carousel__item-wrapper"
                  data-testid="pet-article"
                >
                  <Article
                    title={article.title || ''}
                    position={index + 1}
                    link={article.link}
                    maxLinesInTitle={isMinLarge ? 2 : 4}
                    image={article.image}
                    isSpecialtyPet={isSpecialtyPet}
                  />
                </KibCarouselItem>
              ))}
            </KibCarousel>
          </>
        )}
      </section>
    );
  }
  return null;
};
Articles.displayName = 'Articless';
export default Articles;
